const LI_FORM_ID = /^li-(.+?)-?$/i;
const COUNTRY_FORM_ID = /^[^-]+-custom-(.+)$/i;
const CUSTOM_GEO_TYPE = 'custom';

/**
 * The `li-<code>-` id of a custom location given as `li-<code>-` or `<country>-custom-<code>`; undefined when
 * the id names no custom location.
 */
export function customLocationId(locationId: string): string | undefined {
  const trimmed = locationId.trim();
  const geoCode = LI_FORM_ID.exec(trimmed)?.[1] ?? COUNTRY_FORM_ID.exec(trimmed)?.[1];
  return geoCode === undefined ? undefined : `li-${geoCode}-`;
}

/** Whether two ids name the same location, a custom one given in either of its forms. */
export function sameLocationId(a: string, b: string): boolean {
  return a.trim() === b.trim() || (customLocationId(a) !== undefined && customLocationId(a) === customLocationId(b));
}

/** Whether a location id names a custom location, made of census parts rather than being one itself. */
export function isCustomLocationId(locationId: string): boolean {
  return customLocationId(locationId) !== undefined;
}

/** A location's id from its parts: `li-<code>-` for a custom location, `<country>-<geo type>-<code>` for a census one. */
export function locationIdFromParts(countryCode: string | undefined, geoType: string | undefined, geoCode: string | undefined): string {
  if (geoType?.toLowerCase() === CUSTOM_GEO_TYPE && geoCode) {
    return `li-${geoCode}-`;
  }
  return `${countryCode}-${geoType}-${geoCode}`;
}
